import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getStyle, mapStyleProperties } from './Style.js';
import JSXStyle from 'styled-jsx/style';

export default class TextComponent extends Component {
	render() {
		let { lang } = this.props;
		const { component, style, styleblock, stylesMap } = this.props;

		let text = { __html: component.text };

		if (!lang) {
			lang = localStorage.getItem('language')
				? localStorage.getItem('language')
				: 'en';
		}

		if (!!lang && !!component.text_lang && !!component.text_lang[lang]) {
			text = { __html: component.text_lang[lang] };
		}
		const { id, fullbleed, dropcap } = component;

		let articleBaseStyle = {};

		if (
			component?.article?.StyleID &&
			stylesMap &&
			stylesMap[component?.article?.StyleID] &&
			stylesMap[component?.article?.StyleID]?.properties[
				component.component
			]
		) {
			articleBaseStyle = mapStyleProperties(
				stylesMap[component?.article?.StyleID]?.properties[
					component.component
				]
			);
		}

		let styleComponent = {
			...articleBaseStyle,
			...getStyle(component.component, style, styleblock),
		};

		let css = '';

		if (!!style[component.component] && !!style[component.component].css) {
			css = `.jsx-${id} {
			${style[component.component].css}
		}`;
		}

		const marginBottom = styleComponent.marginBottom || 0;
		if (styleComponent.marginBottom) {
			delete styleComponent.marginBottom;
		}

		const marginTop = styleComponent.marginTop || 0;
		if (styleComponent.marginTop) {
			delete styleComponent.marginTop;
		}

		let fontBoldCSS = '';
		let fontItalicCSS = '';
		let fontBoldItalicCSS = '';
		let anchorCSS = '';

		if (styleComponent.fontFamilyBold) {
			fontBoldCSS = `.jsx-${id} > p b {
				font-family: ${styleComponent.fontFamilyBold} !important;
				font-weight: normal;
			}`;
		}

		if (styleComponent.fontFamilyItalic) {
			fontItalicCSS = `.jsx-${id} > p i {
				font-family: ${styleComponent.fontFamilyItalic};
				font-style: normal;
			}`;
		}

		if (styleComponent.fontFamilyBoldItalic) {
			fontBoldItalicCSS = `.jsx-${id} > p b i {
				font-family: ${styleComponent.fontFamilyBoldItalic};
				font-weight: normal;
  				font-style: normal;
			}`;
		}

		if (style?.anchor) {
			const color = `#${
				style?.anchor.color
					? style['anchor']['color'].replace('#', '')
					: styleComponent['color']
					? styleComponent['color'].replace('#', '')
					: '0000EE'
			}`;
			
			const fontStyle = style.anchor.font_style;
			const fontWeight = style.anchor.font_weight;
			const textDecoration = style.anchor.text_decoration;
			const textTransform = style.anchor.text_transform;

			anchorCSS = `.jsx-${id} a {
				color: ${color};
				${fontStyle ? `font-style: ${fontStyle};` : ''}
				${fontWeight ? `font-weight: ${fontWeight};` : ''}
				${textDecoration ? `text-decoration: ${textDecoration};` : ''}
				${textTransform ? `text-transform: ${textTransform};` : ''}
			};`;
		}

		let dropCapCSS = '';

		// TODO Review Dropcap margin top
		if (dropcap && dropcap == 'on') {
			let dropcapLineHeight = null;
			if (
				styleComponent?.dropcapFontSize &&
				styleComponent?.dropcapLineHeight
			) {
				const lineHeight = parseFloat(
					`${styleComponent?.dropcapLineHeight}`
				);
				const fontSize = parseFloat(styleComponent?.dropcapFontSize);
				dropcapLineHeight = `${fontSize * lineHeight}em`;
			}
			dropCapCSS = `
				.jsx-${id} > :first-child::first-letter {
					float: left;
					font-size: ${styleComponent?.dropcapFontSize || '4em'};
					${dropcapLineHeight ? `line-height: ${dropcapLineHeight} em` : ''}
					margin-left: -2px;
					padding-right: ${styleComponent?.dropcapPaddingRight || '8px'};
					${styleComponent?.dropcapColor ? `color: ${styleComponent?.dropcapColor};` : ''}
				}
			`;
		}

		const {
			background,
			paddingTop,
			paddingBottom,
			paddingLeft,
			paddingRight,
			textDisplay,
		} = styleComponent;

		const componentCSS = `
			.jsx-${id} > p {
				margin: 0px;
				margin-bottom: ${marginBottom};
				margin-top: ${marginTop};
				max-width: 100%;
				${background ? `background: ${background};` : ''}
				${paddingTop ? `padding-top: ${paddingTop};` : ''}
				${paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}
				${paddingLeft ? `padding-left: ${paddingLeft};` : ''}
				${paddingRight ? `padding-right: ${paddingRight};` : ''}
				${fullbleed === 'on' ? 'min-width: 100%;' : ''}
				${textDisplay ? `display: ${textDisplay};` : 'display: block;'}
			}
			
			.jsx-${id} > p > sub {
				font-size: 65%;
				line-height: 0;
				vertical-align: sub;
			}
			
			.jsx-${id} > p > sup {
				font-size: 65%;
				line-height: 0;
				vertical-align: super;
			}

			.jsx-${id} i {
				font-style: italic;
			}
			
			${anchorCSS}
			${fontBoldCSS}
			${fontItalicCSS}
			${fontBoldItalicCSS}
			${dropCapCSS}
			${css}
		`;

		// Remove from container
		if (background) {
			delete styleComponent.background;
		}
		if (paddingTop) {
			delete styleComponent.paddingTop;
		}
		if (paddingBottom) {
			delete styleComponent.paddingBottom;
		}

		if (textDisplay) {
			delete styleComponent.textDisplay;
		}

		styleComponent.padding = 0;

		switch (component.component) {
			case 'headline':
			case 'title':
			case 'subtitle':
			case 'intro':
			case 'body':
			case 'crosshead':
			case 'byline':
			case 'blockquote':
			case 'text1':
			case 'text2':
			case 'text3':
			case 'text4':
			case 'text5':
			case 'text6':
			case 'text7':
			case 'text8':
			case 'text9':
			case 'text10':
			case 'footer':
				return (
					<div
						style={{
							width: '100%',
							overflowWrap: 'break-word',
						}}
					>
						<div
							className={`jsx-${id}`}
							dangerouslySetInnerHTML={text}
							style={styleComponent}
						/>
						<JSXStyle id={id}>{componentCSS}</JSXStyle>
					</div>
				);
			default:
				return null;
		}
	}
}

TextComponent.propTypes = {
	component: PropTypes.object.isRequired,
	style: PropTypes.object,
	styleblock: PropTypes.object,
	stylesMap: PropTypes.any,
	lang: PropTypes.string,
};
